import { onboardingGraph } from "@/data/onboarding";
import { useOnboarding } from "@/hooks/useOnboarding";

type Props = {
  affirmative?: boolean;
  negative?: boolean;
  to: string;
};
export default function Answered({
  affirmative,
  negative,
  to,
  children,
}: React.PropsWithChildren<Props>) {
  const { answers } = useOnboarding();

  const questionIds = Object.keys(onboardingGraph);

  if (!questionIds.includes(to)) {
    console.warn(`Unrecognized questionId: ${to}`);
  }

  if (answers[to] === undefined) {
    console.warn(`Unanswered questionId: ${to}`);
  }

  if (affirmative && answers[to]) {
    return children;
  }

  // "Vet ej" is 2 by convention.
  if (negative && (!answers[to] || answers[to] === 2)) {
    return children;
  }

  return null;
}
